import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { openCookieSettings } from "../../legal/CookieBanner";
import { CompanyPolicyLinks } from "../../legal/LegalFooterLinks";
import { Cloud } from "lucide-react";
import { NAV_LINKS } from "../../mock";

const Footer = () => {
  const navigate = useNavigate();
  const cols = [
    {
      title: "Product",
      links: ["Platform", "How it works", "Use cases", "Roles", "Pricing"],
    },

  ];

  return (
    <footer className="border-t border-border bg-secondary/40">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                <Cloud className="h-5 w-5" strokeWidth={2.2} />
              </span>
              <span className="font-display text-xl font-bold tracking-tight">
                Nimbus
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
              A data agent that runs real tools on your files and audits
              every figure it reports.
            </p>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-sm font-semibold text-foreground">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => {
                  const nav = NAV_LINKS.find((n) => n.label === link);
                  return (
                    <li key={link}>
                      <button
                        onClick={() => {
                          if (nav) {
                            const el = document.querySelector(nav.href);
                            if (el) el.scrollIntoView({ behavior: "smooth" });
                            else navigate("/" + nav.href);
                          }
                        }}
                        className="text-sm text-muted-foreground transition-colors hover:text-primary"
                      >
                        {link}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-border pt-8 sm:flex-row">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Nimbus by Headkey Software Technologies Private Limited (CIN U72900KA2019PTC130529).
          </p>
          <div className="flex gap-6 text-xs text-muted-foreground">
            <Link to="/pricing" className="hover:text-primary" data-testid="footer-pricing-link">Pricing</Link>
            <Link to="/privacy" className="hover:text-primary">Privacy</Link>
            <Link to="/terms" className="hover:text-primary">Terms</Link>
            <Link to="/cookies" className="hover:text-primary">Cookies</Link>
            <Link to="/refund" className="hover:text-primary">Refunds</Link>
            <a href="https://razorpay.me/@headkeysoftwaretechnologiespr" target="_blank" rel="noopener noreferrer" className="hover:text-primary" data-testid="footer-pay-us-link">Pay us</a>
            <Link to="/help" className="hover:text-primary" data-testid="footer-help-link">Help</Link>
            <button type="button" onClick={openCookieSettings} className="hover:text-primary">Cookie settings</button>
          </div>
        </div>
        <CompanyPolicyLinks className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground sm:justify-end"
          linkClassName="underline hover:text-primary" />
      </div>
    </footer>
  );
};

export default Footer;
